import appConfig from '../../config/app';
import { getAuthHeaders } from './auth';

export async function getAvailablePermissions(gymUid) {
  const options = await getAuthHeaders();
  const res = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/permissions`,
    {
      headers: {
        ...options,
      },
    }
  );
  if (!res.ok) {
    throw new Error('Failed to fetch permissions');
  }
  return res.json();
}

export async function getAssignedPermissions(gymUid) {
  const options = await getAuthHeaders();
  const res = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/user_permissions`,
    {
      headers: {
        ...options,
      },
    }
  );
  if (!res.ok) {
    throw new Error('Failed to fetch assigned permissions');
  }
  return res.json();
}
